'use client';

import Link from 'next/link';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { track } from '@/lib/analytics/ym';
import { SITE } from '@/lib/site-config';

const links = [
  { href: '/#cases', label: 'Кейсы' },
  { href: '/#process', label: 'Процесс' },
  { href: '/#faq', label: 'Вопросы' },
];

export function Navbar() {
  return (
    <header className="sticky top-0 z-40 border-b bg-background/80 backdrop-blur-md">
      <nav className="container mx-auto flex h-16 items-center justify-between px-4 md:h-18">
        <Link href="/" className="font-semibold tracking-tight">
          {SITE.brand}
        </Link>
        <ul className="hidden items-center gap-6 md:flex">
          {links.map((l) => (
            <li key={l.href}>
              <Link href={l.href} className="text-sm text-muted-foreground hover:text-foreground">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
        <div className="hidden md:flex items-center gap-2">
          <Link
            href="/#lead"
            onClick={() => track.ctaClick('navbar')}
            className={cn(buttonVariants({ size: 'sm' }), 'rounded-full')}
          >
            Запросить аудит
          </Link>
        </div>
      </nav>
    </header>
  );
}
